import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import logo from "../assets/images/logo.svg"
import payment from "../assets/images/payment.png"
import { get_settings_section } from '../api/Global';
import { IMG_BASE_URL } from '../config/Base_Url_Config';


const Footer = () => {
  const [get_settings, set_get_settings] = useState({});

  useEffect(() => {
    const handle_get_settings = async () => {
      try {
        const response = await get_settings_section();
        set_get_settings(response?.data?.data?.settings)
      } catch (error) {
        console.log("error", error)
      }
    }
    handle_get_settings();
  }, [])
  return (
    <footer className="border_top bg-[#111] relative lg:pt-12">
      <div className="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
        <div className="md:flex md:justify-between gap-8">
          <div className="mb-6 md:mb-0">
            <Link to="/" className="flex items-center">
              {
                get_settings?.header_logo != null ? (
                  <img alt="Your Company" src={`${IMG_BASE_URL}/${get_settings?.header_logo}`} className="h-6 md:h-8 w-auto me-4" />
                ) : (
                  <img alt="Your Company" src={logo} className="h-6 md:h-8 w-auto me-4" />
                )
              }
            </Link>
            <p className="text-white mt-5 font-bold">{get_settings?.description}</p>
            <p className="text-white">{get_settings?.email}</p>
            <p className="text-white">{get_settings?.phone}</p>
          </div>
          <div className="grid grid-cols-3 gap-8 sm:gap-6 sm:grid-cols-3">
            {[
              {
                title: "Hosting",
                links: [
                  { name: "Web Hosting", href: "/hosting" },
                  { name: "WordPress Hosting", href: "/wordpress-hosting" },
                  { name: "Shared Hosting", href: "/shared-hosting" },
                  { name: "Dedicated Hosting", href: "/dedicated-hosting" },
                  { name: "VPS Hosting", href: "/vps-hosting" }
                ]
              },
              {
                title: "Domain",
                links: [
                  { name: "Domain", href: "/domain" }
                ]
              },
              {
                title: "Support",
                links: [
                  
                  { name: "Contact Us", href: "/contact-us" },
                  { name: "Privacy and Policy", href: "/privacy-policy" },
                  { name: "Passport Account Agreement", href: "/agreement", isPdf: true },
                  { name: "Terms and Conditions", href: "/terms-of-service" },
                ]
              }
            ].map((section, index) => (
              <div key={index}>
                <h2 className="mb-6 text-sm font-semibold text-gray-300 uppercase dark:text-white">
                  {section.title}
                </h2>
                <ul className="text-gray-500 dark:text-gray-400 p-0">
                  {section.links.map((link, i) => (
                    <li key={i} className="mb-3">
          {link.isPdf ? (
            <a
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 font-medium no-underline hover:underline"
            >
              {link.name}
            </a>
          ) : (
            <Link
              to={link.href}
              className="text-gray-400 font-medium no-underline hover:underline"
            >
              {link.name}
            </Link>
          )}
        </li>
                  ))}
                </ul>
              </div>
            ))}

          </div>
        </div>
        <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
        <div class="text-gray-400 font-medium no-underline">"Money transmission services relating to the Passport Program are provided by Priority, directly or through its subsidiary Finxera, Inc. (NMLS #1168701) or its authorized affiliates and contractors."</div>
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
            © 2025 <Link to="/" className="hover:underline">Locknpay</Link>. All Rights Reserved.
          </span>
          <div className="mt-4 sm:justify-center sm:mt-0">
            <img src={payment} alt="Payment Methods" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
